@if (settingsLoading()) {
  <div class="admin-feedback">
    <div class="status-text">Loading admin settings...</div>
  </div>
}
@if (settingsError()) {
  <div class="admin-feedback">
    <div class="error-banner" role="alert">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="currentColor"
        viewBox="0 0 16 16"
        class="error-banner-icon"
      >
        <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m.93-11.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2" />
      </svg>
      <span class="error-banner-message">{{ settingsError() }}</span>
      <button type="button" class="error-banner-dismiss" (click)="clearSettingsError()" aria-label="Dismiss error">
        ✕
      </button>
    </div>
  </div>
}
<div class="admin-shell">
  <div class="admin-panels-row">

  <!-- STREAM PANEL -->
  <section class="admin-panel">
    <h2 class="card-title flex items-center gap-2">
      <div class="header-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          class="bi bi-camera-video"
          viewBox="0 0 16 16"
        >
          <path
            fill-rule="evenodd"
            d="M0 5a2 2 0 0 1 2-2h7.5a2 2 0 0 1 1.983 1.738l3.11-1.382A1 1 0 0 1 16 4.269v7.462a1 1 0 0 1-1.406.913l-3.111-1.382A2 2 0 0 1 9.5 13H2a2 2 0 0 1-2-2zm11.5 5.175 3.5 1.556V4.269l-3.5 1.556zM2 4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h7.5a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1z"
          />
        </svg>
      </div>
      Stream Panel
    </h2>
    <div class="divider mb-4"></div>
    @if (settings()) {
      <div class="flex items-center justify-between">
        <div class="flex flex-col">
          <span>Video Stream</span>
          <span class="text-xs text-[var(--text-secondary)]"
            >Enable or disable the live main/driver feed
		  </span>
          @if (settings()?.race?.disableStream) {
            <div class="stream-status-inactive text-xs p-1 rounded mt-3">
              <strong>• STREAM INACTIVE</strong>
            </div>
          } @else {
            <div class="stream-status-active text-xs p-1 rounded mt-3">
              <strong>• STREAM ACTIVE</strong>
            </div>
          }
        </div>
        <vb-lxp-switch
          [checked]="driverStreamStatus()"
          [saveFn]="saveDriverStreamStatus"
        ></vb-lxp-switch>
      </div>
	  <div class="flex items-center gap-4 mt-6">
        <div class="divider"></div>
        <span class="text-xs text-text-secondary"><strong>DATA MANAGEMENT</strong></span>
        <div class="divider"></div>
      </div>
      <div class="mt-4">
        <div class="flex flex-col gap-2">
          <span class="text-sm">Production Data Reset</span>
          <span class="text-xs text-[var(--text-secondary)]">Clear cached production data and reconnect to AlKamel</span>
          <button 
            class="btn-primary mt-2" 
            [disabled]="isResettingProdData()"
            (click)="onResetProdDataClicked()">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="mr-2" viewBox="0 0 16 16">
              <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"/>
              <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466"/>
            </svg>
            <span>{{ isResettingProdData() ? 'Resetting...' : 'Reset Production Data' }}</span>
          </button>
        </div>
      </div>
      <div class="flex items-center gap-4 mt-4">
        <div class="divider"></div>
        <span class="text-xs text-text-secondary"><strong>UPLOAD CONFIG</strong></span>
        <div class="divider"></div>
      </div>

      <div
        class="upload-zone mt-4"
        [class.drag-over]="isDragging()"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onDrop($event)"
        (click)="browseFile()"
      >
        <input #fileInput type="file" accept=".json" hidden (change)="onFileSelected($event)" />
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" viewBox="0 0 16 16" class="upload-icon">
          <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5"/>
          <path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708z"/>
        </svg>
        <p class="upload-title">Drag &amp; drop your JSON file here</p>
        <p class="upload-subtitle">or <span class="upload-browse-link">browse files</span> — .json up to 10 MB</p>
        @if (uploadedFileName()) {
          <p class="upload-success-text">✓ {{ uploadedFileName() }}</p>
        }
      </div>
      @if (uploadError()) {
        <p class="upload-error-text mt-2">{{ uploadError() }}</p>
      }
      @if (expectedJsonStructure()) {
        <button class="btn-clear-data mt-3" [disabled]="isUploadSaving()" (click)="clearStreamingData()">
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" viewBox="0 0 16 16">
            <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z"/>
            <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z"/>
          </svg>
          Clear uploaded data
        </button>
      }
      @if (!expectedJsonStructure()) {
      <div class="json-structure mt-4">
        <div class="json-structure-label">EXPECTED JSON STRUCTURE</div>
        <pre class="json-structure-code">&#123;
		"id": "1",
		"teamName": "team-name",
		"carNumber": "30",
		"carDeviceNumber": "2342",
		"rtmpUrl": "rtmp://...",
		"rtmpStreamKey": "key",
		"eip": "1.2.3.4",
		"eipAllocationId": "eipalloc-...",
		"videoId": "video-id",
		"hlsPlaybackUrl": "https://...",
		"isLive": true
		&#125;</pre>
      </div>
    }
    }
  </section>
  <!-- /STREAM PANEL -->

  <!-- ADMIN PANEL -->
  <section class="admin-panel">
    <h2 class="card-title flex items-center gap-2">
      <div class="header-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          class="bi bi-bell"
          viewBox="0 0 16 16"
        >
          <path
            d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2M8 1.918l-.797.161A4 4 0 0 0 4 6c0 .628-.134 2.197-.459 3.742-.16.767-.376 1.566-.663 2.258h10.244c-.287-.692-.502-1.49-.663-2.258C12.134 8.197 12 6.628 12 6a4 4 0 0 0-3.203-3.92zM14.22 12c.223.447.481.801.78 1H1c.299-.199.557-.553.78-1C2.68 10.2 3 6.88 3 6c0-2.42 1.72-4.44 4.005-4.901a1 1 0 1 1 1.99 0A5 5 0 0 1 13 6c0 .88.32 4.2 1.22 6"
          />
        </svg>
      </div>
      Notification Panel
    </h2>
    <div class="divider mb-3"></div>
    <div class="flex mb-3">
      <span class="text-xs status-text"><strong>COMPOSE MESSAGE</strong></span>
      <div class="grow-1"></div>
      <span class="status-text">{{ notificationMessageLength() }} / 300</span>
    </div>
    <textarea
      [ngModel]="notificationMessageDraft()"
      (ngModelChange)="onNotificationMessageChanged($event)"
      class="message-textarea mb-3"
      maxlength="300"
      placeholder="Type your notification message to broadcast to the live site…"
    ></textarea>
    <div class="flex gap-2">
      <button
        class="btn-primary grow-1"
        [disabled]="!canSendNotification()"
        (click)="onSendToSiteClicked()"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          class="mr-2"
          fill="currentColor"
          viewBox="0 0 16 16"
        >
          <path
            d="M15.854.146a.5.5 0 0 1 .11.54l-5.819 14.547a.75.75 0 0 1-1.329.124l-3.178-4.995L.643 7.184a.75.75 0 0 1 .124-1.33L15.314.037a.5.5 0 0 1 .54.11ZM6.636 10.07l2.761 4.338L14.13 2.576zm6.787-8.201L1.591 6.602l4.339 2.76z"
          /></svg>
        <span>Send to Site</span>
      </button>
      <button class="btn-outline" [disabled]="isNotificationSaving()" (click)="onClearBannerMessageClicked()">Clear</button>
    </div>
  </section>
  <!-- /ADMIN PANEL -->

  </div><!-- /admin-panels-row -->

  @if (expectedJsonStructure(); as streamingRows) {
  <vb-lxp-streaming-table [rows]="streamingRows"></vb-lxp-streaming-table>
  }

  <div class="toast" [ngClass]="[showToast() ? 'toast-enter' : '']">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      class="bi bi-info-circle"
      viewBox="0 0 16 16"
    >
      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
      <path
        d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
      />
    </svg>
    <span>{{ toastMessage() }}</span>
  </div>

  <!-- Reset Confirmation Modal -->
  @if (showResetConfirmModal()) {
  <div class="modal-overlay" (click)="onCancelResetProdData()">
    <div class="modal-container" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <div class="modal-icon-wrapper">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16" class="modal-icon">
            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
            <path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0M7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0z"/>
          </svg>
        </div>
        <h3 class="modal-title">Reset Production Data?</h3>
        <button type="button" class="modal-close" (click)="onCancelResetProdData()" aria-label="Close modal">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z"/>
          </svg>
        </button>
      </div>
      <div class="modal-body">
        <p class="modal-description">This action will perform the following operations:</p>
        <ul class="modal-list">
          <li>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" class="list-icon">
              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
              <path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05"/>
            </svg>
            Clear all cached production data
          </li>
          <li>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" class="list-icon">
              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
              <path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05"/>
            </svg>
            Disconnect from AlKamel server
          </li>
          <li>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" class="list-icon">
              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
              <path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05"/>
            </svg>
            Reconnect and fetch fresh data
          </li>
        </ul>
        <p class="modal-warning">This operation cannot be undone.</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="modal-btn-secondary" (click)="onCancelResetProdData()">
          Cancel
        </button>
        <button type="button" class="modal-btn-primary" (click)="onConfirmResetProdData()">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="mr-2" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"/>
            <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466"/>
          </svg>
          Reset Production Data
        </button>
      </div>
    </div>
  </div>
  }
</div>
